/* GENERATED by scripts/gen-data.mjs — bibliography — paper titles are not translated (from s1.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { RefRow } from '../types';

export const REFS: Record<string, RefRow> = {
  "attn": {
    "id": "1706.03762",
    "t": "Attention Is All You Need",
    "topic": "foundations"
  },
  "calib": {
    "id": "1706.04599",
    "t": "On Calibration of Modern Neural Networks",
    "topic": "foundations"
  },
  "zshot": {
    "id": "1909.00161",
    "t": "Benchmarking Zero-shot Text Classification: Datasets, Evaluation and Entailment Approach",
    "topic": "models"
  },
  "nli": {
    "id": "1704.05426",
    "t": "A Broad-Coverage Challenge Corpus for Sentence Understanding through Inference",
    "topic": "models"
  },
  "ner": {
    "id": "1812.09449",
    "t": "A Survey on Deep Learning for Named Entity Recognition",
    "topic": "models"
  },
  "sbert": {
    "id": "1908.10084",
    "t": "Sentence-BERT: Sentence Embeddings using Siamese BERT-Networks",
    "topic": "models"
  },
  "hallu": {
    "id": "2202.03629",
    "t": "Survey of Hallucination in Natural Language Generation",
    "topic": "models"
  },
  "mteb": {
    "id": "2210.07316",
    "t": "MTEB: Massive Text Embedding Benchmark",
    "topic": "retrieval"
  },
  "rag": {
    "id": "2005.11401",
    "t": "Retrieval-Augmented Generation for Knowledge-Intensive NLP Tasks",
    "topic": "retrieval"
  },
  "ragsurvey": {
    "id": "2312.10997",
    "t": "Retrieval-Augmented Generation for Large Language Models: A Survey",
    "topic": "retrieval"
  },
  "selfrag": {
    "id": "2310.11511",
    "t": "Self-RAG: Learning to Retrieve, Generate, and Critique through Self-Reflection",
    "topic": "retrieval"
  },
  "lostmid": {
    "id": "2307.03172",
    "t": "Lost in the Middle: How Language Models Use Long Contexts",
    "topic": "retrieval"
  },
  "memsurvey": {
    "id": "2404.13501",
    "t": "A Survey on the Memory Mechanism of Large Language Model-based Agents",
    "topic": "retrieval"
  },
  "memgpt": {
    "id": "2310.08560",
    "t": "MemGPT: Towards LLMs as Operating Systems",
    "topic": "architecture"
  },
  "memllm": {
    "id": "2404.11672",
    "t": "MemLLM: Finetuning LLMs to Use An Explicit Read-Write Memory",
    "topic": "retrieval"
  },
  "genagents": {
    "id": "2304.03442",
    "t": "Generative Agents: Interactive Simulacra of Human Behavior",
    "topic": "architecture"
  },
  "hnsw": {
    "id": "1603.09320",
    "t": "Efficient and robust approximate nearest neighbor search using Hierarchical Navigable Small World graphs",
    "topic": "retrieval"
  },
  "littles": {
    "id": "1901.02926",
    "t": "Three Other Models of Computer System Performance",
    "topic": "events"
  },
  "kafkaflink": {
    "id": "2410.15533",
    "t": "Real-time Event Joining in Practice With Kafka and Flink",
    "topic": "events"
  },
  "kafkapats": {
    "id": "2512.16146",
    "t": "Analysis of Design Patterns and Benchmark Practices in Apache Kafka Event-Streaming Systems",
    "topic": "events"
  },
  "micro": {
    "id": "1606.04036",
    "t": "Microservices: yesterday, today, and tomorrow",
    "topic": "architecture"
  },
  "sarathi": {
    "id": "2403.02310",
    "t": "Taming Throughput-Latency Tradeoff in LLM Inference with Sarathi-Serve",
    "topic": "production"
  },
  "vllm": {
    "id": "2309.06180",
    "t": "Efficient Memory Management for Large Language Model Serving with PagedAttention",
    "topic": "production"
  },
  "mfe": {
    "id": "2007.00293",
    "t": "Motivations, Benefits, and Issues for Adopting Micro-Frontends: A Multivocal Literature Review",
    "topic": "architecture"
  },
  "mfemig": {
    "id": "2407.15829",
    "t": "Investigating Benefits and Limitations of Migrating to a Micro-Frontends Architecture",
    "topic": "architecture"
  },
  "react": {
    "id": "2210.03629",
    "t": "ReAct: Synergizing Reasoning and Acting in Language Models",
    "topic": "tooling"
  },
  "cot": {
    "id": "2201.11903",
    "t": "Chain-of-Thought Prompting Elicits Reasoning in Large Language Models",
    "topic": "tooling"
  },
  "toolformer": {
    "id": "2302.04761",
    "t": "Toolformer: Language Models Can Teach Themselves to Use Tools",
    "topic": "tooling"
  },
  "swebench": {
    "id": "2310.06770",
    "t": "SWE-bench: Can Language Models Resolve Real-World GitHub Issues?",
    "topic": "tooling"
  },
  "guard": {
    "id": "2312.06674",
    "t": "Llama Guard: LLM-based Input-Output Safeguard for Human-AI Conversations",
    "topic": "safety"
  },
  "inj": {
    "id": "2306.05499",
    "t": "Prompt Injection attack against LLM-integrated Applications",
    "topic": "safety"
  },
  "jailbreak": {
    "id": "2307.15043",
    "t": "Universal and Transferable Adversarial Attacks on Aligned Language Models",
    "topic": "safety"
  },
  "conformal": {
    "id": "2107.07511",
    "t": "A Gentle Introduction to Conformal Prediction and Distribution-Free Uncertainty Quantification",
    "topic": "safety"
  },
  "guided": {
    "id": "2307.09702",
    "t": "Efficient Guided Generation for Large Language Models",
    "topic": "safety"
  },
  "mcards": {
    "id": "1810.03993",
    "t": "Model Cards for Model Reporting",
    "topic": "safety"
  },
  "datasheet": {
    "id": "1803.09010",
    "t": "Datasheets for Datasets",
    "topic": "safety"
  },
  "hitl": {
    "id": "2202.10564",
    "t": "Human-in-the-loop Machine Learning: A Macro-Micro Perspective",
    "topic": "safety"
  },
  "checklist": {
    "id": "2005.04118",
    "t": "Beyond Accuracy: Behavioral Testing of NLP models with CheckList",
    "topic": "evaluation"
  },
  "helm": {
    "id": "2211.09110",
    "t": "Holistic Evaluation of Language Models",
    "topic": "evaluation"
  },
  "llmjudge": {
    "id": "2306.05685",
    "t": "Judging LLM-as-a-Judge with MT-Bench and Chatbot Arena",
    "topic": "evaluation"
  },
  "mltest": {
    "id": "1906.10742",
    "t": "Machine Learning Testing: Survey, Landscapes and Horizons",
    "topic": "evaluation"
  },
  "drift": {
    "id": "1010.4784",
    "t": "Learning under Concept Drift: an Overview",
    "topic": "production"
  },
  "dpsgd": {
    "id": "1607.00133",
    "t": "Deep Learning with Differential Privacy",
    "topic": "production"
  },
  "anomdet": {
    "id": "2202.07787",
    "t": "Trustworthy Anomaly Detection: A Survey",
    "topic": "production"
  },
  "layoutlm": {
    "id": "1912.13318",
    "t": "LayoutLM: Pre-training of Text and Layout for Document Image Understanding",
    "topic": "production"
  },
  "infer": {
    "id": "2404.14294",
    "t": "A Survey on Efficient Inference for Large Language Models",
    "topic": "cost"
  },
  "gptq": {
    "id": "2210.17323",
    "t": "GPTQ: Accurate Post-Training Quantization for Generative Pre-trained Transformers",
    "topic": "cost"
  },
  "lora": {
    "id": "2106.09685",
    "t": "LoRA: Low-Rank Adaptation of Large Language Models",
    "topic": "cost"
  },
  "frugal": {
    "id": "2305.05176",
    "t": "FrugalGPT: How to Use Large Language Models While Reducing Cost and Improving Performance",
    "topic": "cost"
  },
  "routellm": {
    "id": "2406.18665",
    "t": "RouteLLM: Learning to Route LLMs with Preference Data",
    "topic": "cost"
  },
  "pcache": {
    "id": "2311.04934",
    "t": "Prompt Cache: Modular Attention Reuse for Low-Latency Inference",
    "topic": "cost"
  },
  "specdec": {
    "id": "2211.17192",
    "t": "Fast Inference from Transformers via Speculative Decoding",
    "topic": "cost"
  },
  "curri": {
    "id": "2101.10382",
    "t": "Curriculum Learning: A Survey",
    "topic": "learning"
  },
  "spaced": {
    "id": "1712.01856",
    "t": "Optimizing Human Learning",
    "topic": "learning"
  },
  "hlr": {
    "id": "",
    "v": "ACL 2016",
    "t": "A Trainable Spaced Repetition Model for Language Learners",
    "topic": "learning"
  },
  "kt": {
    "id": "1506.05908",
    "t": "Deep Knowledge Tracing",
    "topic": "learning"
  },
  "testing": {
    "id": "",
    "v": "Psychological Science 2006",
    "t": "Test-Enhanced Learning: Taking Memory Tests Improves Long-Term Retention",
    "topic": "learning"
  },
  "retrieval": {
    "id": "",
    "v": "Science 2011",
    "t": "Retrieval Practice Produces More Learning than Elaborative Studying with Concept Mapping",
    "topic": "learning"
  },
  "interleave": {
    "id": "",
    "v": "Instructional Science 2007",
    "t": "The shuffling of mathematics problems improves learning",
    "topic": "learning"
  },
  "feedback": {
    "id": "",
    "v": "Review of Educational Research 2007",
    "t": "The Power of Feedback",
    "topic": "learning"
  },
  "clt": {
    "id": "",
    "v": "Cognitive Science 1988",
    "t": "Cognitive Load During Problem Solving: Effects on Learning",
    "topic": "learning"
  },
  "slmsurvey": {
    "id": "2410.20011",
    "t": "A Survey of Small Language Models",
    "topic": "scale"
  },
  "slmmeasure": {
    "id": "2409.15790",
    "t": "Small Language Models: Survey, Measurements, and Insights",
    "topic": "scale"
  },
  "textbooks": {
    "id": "2306.11644",
    "t": "Textbooks Are All You Need",
    "topic": "scale"
  },
  "scalelaw": {
    "id": "2001.08361",
    "t": "Scaling Laws for Neural Language Models",
    "topic": "scale"
  },
  "emerge": {
    "id": "2206.07682",
    "t": "Emergent Abilities of Large Language Models",
    "topic": "scale"
  },
  "mirage": {
    "id": "2304.15004",
    "t": "Are Emergent Abilities of Large Language Models a Mirage?",
    "topic": "scale"
  },
  "chinchilla": {
    "id": "2203.15556",
    "t": "Training Compute-Optimal Large Language Models",
    "topic": "scale"
  },
  "distill": {
    "id": "2503.12067",
    "t": "A Comprehensive Survey on Knowledge Distillation",
    "topic": "scale"
  },
  "dstep": {
    "id": "2305.02301",
    "t": "Distilling Step-by-Step! Outperforming Larger Language Models with Less Training Data and Smaller Model Sizes",
    "topic": "scale"
  },
  "sft": {
    "id": "2308.10792",
    "t": "Instruction Tuning for Large Language Models: A Survey",
    "topic": "scale"
  },
  "beir": {
    "id": "2104.08663",
    "t": "BEIR: A Heterogenous Benchmark for Zero-shot Evaluation of Information Retrieval Models",
    "topic": "retrieval"
  },
  "chunk": {
    "id": "2312.06648",
    "t": "Dense X Retrieval: What Retrieval Granularity Should We Use?",
    "topic": "retrieval"
  },
  "rerank": {
    "id": "2010.06467",
    "t": "Pretrained Transformers for Text Ranking: BERT and Beyond",
    "topic": "retrieval"
  },
  "ragas": {
    "id": "2309.15217",
    "t": "Ragas: Automated Evaluation of Retrieval Augmented Generation",
    "topic": "retrieval"
  },
  "evedit": {
    "id": "2408.00440",
    "t": "An Empirical Study on Challenges of Event Management in Microservice Architectures",
    "topic": "events"
  },
  "eda": {
    "id": "2308.05270",
    "t": "Uncovering the Hidden Potential of Event-Driven Architecture: A Research Agenda",
    "topic": "events"
  },
  "natsdocs": {
    "id": "",
    "v": "docs.nats.io",
    "t": "NATS JetStream: subjects, streams, consumers",
    "topic": "events"
  },
  "trace": {
    "id": "2311.09032",
    "t": "Nahida: In-Band Distributed Tracing with eBPF",
    "topic": "architecture"
  },
  "cotsurvey": {
    "id": "2309.15402",
    "t": "Navigate through Enigmatic Labyrinth: A Survey of Chain of Thought Reasoning: Advances, Frontiers and Future",
    "topic": "tooling"
  },
  "nl2sql": {
    "id": "2410.01066",
    "t": "From Natural Language to SQL: Review of LLM-based Text-to-SQL Systems",
    "topic": "tooling"
  },
  "agentbench": {
    "id": "2308.03688",
    "t": "AgentBench: Evaluating LLMs as Agents",
    "topic": "tooling"
  },
  "xai": {
    "id": "1910.10045",
    "t": "Explainable Artificial Intelligence (XAI): Concepts, Taxonomies, Opportunities and Challenges toward Responsible AI",
    "topic": "safety"
  },
  "fair": {
    "id": "1908.09635",
    "t": "A Survey on Bias and Fairness in Machine Learning",
    "topic": "safety"
  },
  "spotlight": {
    "id": "2403.14720",
    "t": "Defending Against Indirect Prompt Injection Attacks With Spotlighting",
    "topic": "safety"
  },
  "injreview": {
    "id": "2601.22240",
    "t": "A Systematic Literature Review on LLM Defenses Against Prompt Injection and Jailbreaking: Expanding NIST Taxonomy",
    "topic": "safety"
  },
  "abtest": {
    "id": "2212.11366",
    "t": "Statistical Challenges in Online Controlled Experiments: A Review of A/B Testing Methodology",
    "topic": "evaluation"
  },
  "distract": {
    "id": "2402.01512",
    "t": "Distractor Generation in Multiple-Choice Tasks: A Survey of Methods, Datasets, and Evaluation",
    "topic": "evaluation"
  },
  "dcai": {
    "id": "2303.10158",
    "t": "Data-centric Artificial Intelligence: A Survey",
    "topic": "data"
  },
  "iaa": {
    "id": "2603.06865",
    "t": "Counting on Consensus: Selecting the Right Inter-annotator Agreement Metric for NLP Annotation and Evaluation",
    "topic": "data"
  },
  "dora": {
    "id": "",
    "v": "IT Revolution 2018",
    "t": "Accelerate: The Science of Lean Software and DevOps",
    "topic": "production"
  },
  "sre": {
    "id": "",
    "v": "O\u2019Reilly 2016",
    "t": "Site Reliability Engineering: How Google Runs Production Systems",
    "topic": "production"
  },
  "cascades": {
    "id": "",
    "v": "CHI 2021",
    "t": "“Everyone wants to do the model work, not the data work”: Data Cascades in High-Stakes AI",
    "topic": "data"
  }
};
